import React, {useState} from "react";
import {IconButton, Tooltip} from "@mui/material";
import {ContentCopy} from "@mui/icons-material";
import {translateFunction} from "../../localization/TranslationService";

const translate = translateFunction();

export function CopyButton(props: { getText: () => string }) {
	const [open, setOpen] = useState<boolean>(false);
	
	async function copyToClipboard(text: string) {
		await navigator.clipboard.writeText(text);
		
		setOpen(true);
		
		setTimeout(() => setOpen(false), 1_000);
	}
	
	return <IconButton
		aria-label="copy"
		color="primary"
		size="small"
		disabled={open}
		onClick={() => copyToClipboard(props.getText())}>
		<ContentCopy
			style={{
				fontSize: "16px"
			}}/>
		<Tooltip title={translate("Copied!")} open={open}>
			<div></div>
		</Tooltip>
	</IconButton>;
}
